/**
 * FE-4577 — client-side design-system store and `Fds` delivery negotiation.
 *
 * The backend (FE-4576) keeps a per-device record of what it has delivered and
 * answers with only what this client is missing or holds stale. After the first
 * visit most responses carry no class or template bodies at all, so the renderer
 * resolves them out of this store instead of out of the response.
 */

export {
  FDS_NONE,
  buildFdsPreimage,
  computeFdsHash,
  fdsOf,
  parseFds,
  readFdsResponse,
  serializeFdsRequest,
  sha256Hex,
} from './protocol';
export type { FdsHashInput, FdsResponse } from './protocol';

export {
  getFdsRequestHeader,
  hydrateDesignSystem,
  ingestDelivery,
  isDesignSystemActive,
  isDesignSystemReady,
  readDesignSystem,
  resetDesignSystem,
  setActiveTheme,
  setThemeChangeListener,
} from './store';
export type { DesignSystemState, IngestInput } from './store';

export { clearDesignSystemResolveCache, resolveDeliveredDesignSystem, toCacheableBody } from './resolve';
export type { DeliveredBlocks, ResolvedDesignSystem } from './resolve';
